import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueAxios from "./axios";
//import axios from 'axios'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: {
      pt

    },
    current: 'pt'
  },
  icons: {
    iconfont: "md" // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: "#638246",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        botao_sucesso: "#165B32",
        bota_error: "#E65100",
        branco:"#FFF"
      }
    }
  }

});